import React from 'react'

import PageHeader from "../components/PageHeader";

import "../css/admission.css";
import { vedpathshalaImg } from '../assets/assets.js';


export const Admission = () => {
    return (
        <>  
            
            <PageHeader title="प्रवेश प्रक्रिया माहिती" path="/about-goshala" name=" goshala" />
  

     <div className='admission-section'>
        {/* section */}
        {/* <h1 className='admission-section-title'> <center><h3>प्रवेश प्रक्रिया माहिती</h3></center></h1> */}
        {/* it holds all admission-sub-section */}
        <div className='admission-container'>
         <div className='admission-sub-section' >
        {/* admission-sub-section */}
        <div className='admission-img-container'>
           <img className='admission-image' src={vedpathshalaImg.ved_img_3} alt="" />
        </div>
        <div className='admission-info-container'>
            {/* info container */}
            <p>  &nbsp;  &nbsp;  &nbsp; &nbsp;   &nbsp; &nbsp; या वैदिक गुरुकुलामध्ये प्रवेश घेण्याकरिता वयाची दहा वर्षे अथवा पाचवी पास असणे व त्याला मातृभाषा व हिंदी यांचे लेखन वाचन उत्तम प्रकारे येणे व इंग्रजीचे सामान्य ज्ञान असणे अत्यावश्यक आहे. विद्यार्थी निवड प्रक्रियेतून उत्तीर्ण झाल्यानंतर शिक्षा मंत्रालय अंतर्गत <b style={{color:"red"}}>महर्षी संधीपणी राष्ट्रीय वेध विद्या प्रतिष्ठान उज्जैन</b> यांच्या नियमात बसत असल्यास त्याला गुरुकुलामध्ये ऑनलाईन पद्धतीने प्रवेश दिल्या जातो. 
            <p>याकरिता विद्यार्थ्याचे पालकांसह राष्ट्रीयकृत बँकेमध्ये जॉईंट अकाउंट असणे आवश्यक आहे. तसेच पाठी शाळेचा प्रवेश फॉर्म व आवश्यक ती माहिती पाठशाळेत पुरवणे आवश्यक आहे त्याचबरोबर पाठशाळेच्या नियमावलीचे देखील पालन करणे विद्यार्थी व पालकास बंधनकारक आहे. या वेदपाठशाळेमध्ये परंपरागत उपनयन झालेल्या विद्यार्थ्यासच विविध पाठशाळेच्या अधिकारी व्यक्तींच्या आदेशानेच प्रवेश देण्यात येईल. याव्यतिरिक्त वेदशाळा कोणत्याही विद्यार्थ्यांना जबरदस्तीने प्रवेश देण्यासाठी बाध्य नाही.</p> 
            <b  style={{color:"red"}} > विद्यार्थ्यांना प्रवेश निश्चित झाल्यानंतर गुरुकुलातील तज्ञ वैदिक तसेच आधुनिक विषय अध्यापकांकडून  संस्कृत, गणित, इंग्रजी, सामाजिक विज्ञान व विज्ञान अशा पाचही विषयांचे शिक्षा मंत्रालय भारत सरकार अंतर्गत महर्षी सांदीपनी राष्ट्रीय संस्कृत वेदविद्या बोर्डच्या अंतर्गत शिक्षण दिल्या जाते.</b> याव्यतिरिक्त उपरोक्त प्रवेशाच्या अटीत न बसणाऱ्या परंतु पौरोहित्य ज्योतिष इत्यादी सांस्कृतिक क्षेत्रातील ग्रंथांचे अध्ययन करण्याकरता देखील विद्यार्थ्यांना सशुल्क पद्धतीने शिक्षणाची सुविधा गुरुकुलात उपलब्ध होईल. 
            </p>
        </div>
        </div>
        </div>
     </div>

        </>
    );
}
